import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon, Table, DLMenu } from 'appSrc/components/UI';
import { Link } from 'react-router-dom';
import { convertImage } from 'appSrc/utils';
import style from './styles/style.module.css';

class SortableContentsTable extends PureComponent {
    render() {
        const { contents } = this.props;

        return (
            <div>
                <Table
                className={ style.contentsTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    <Table.Head>
                        <Table.Row draggable={ false }>
                            <Table.Cell></Table.Cell>
                            <Table.Cell style={ { minWidth: '100px' } }></Table.Cell>
                            <Table.Cell>TYPE</Table.Cell>
                            <Table.Cell>NAME</Table.Cell>
                            <Table.Cell>USER</Table.Cell>
                            <Table.Cell>FEATURED</Table.Cell>
                            <Table.Cell>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.SortableBody onChange={ this.props.onSort }>
                        { this.arrayTableRows( contents ) }
                    </Table.SortableBody>
                </Table>
            </div>
        );
    }

    arrayTableRows = ( contents ) => {
        var rows = contents.map( ( content, index ) => {
            let individualSlug = '';
            let rowKey = null;
            let coverImage = null;
            let size = '';
            let type = '';
            
            switch(content.type) {
                case 'curated_article':
                    individualSlug = `/admin/content/${ content.id }`;
                    rowKey = `article-${content.id}`;
                    coverImage = content.cover_image;
                    switch(content.content_type_id) {
                        case 2:
                            type = 'Article';
                            size = '/160x80';
                            break; 
                        case 4:
                            type = 'Class';
                            break; 
                        case 5:
                            type = 'How-To';
                            break; 
                    }
                    break;
                case 'product':
                    individualSlug = `/admin/products/${ content.desireid }`;
                    rowKey = `article-${content.desireid}`;
                    coverImage = content.image;
                    size = '/100x100';
                    type = 'Product';
                    break;
            }
            var author = content.author || {};
            return (
                <Table.Row key={ rowKey }>
                    <Table.Cell className='handle' style={ { cursor: 'grab' } }>
                        <Icon source='fontAwesome' icon='fas/faArrowsAltV' style={ { color: 'inherit' } } />
                    </Table.Cell>
                    <Table.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <img src={ convertImage( coverImage, size ) } style={ { height: '80px' } } />
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }></Link>
                        { type }
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }></Link>
                        { content.title }
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ `/admin/users/${ author.userid }` }></Link>
                        { author.displayName }
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }></Link>
                        { content.featured !== null ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inherit' } } /> ) : null }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Remove'
                            onClick={ () => {
                                this.props.removeContent( index );
                            } }/>
                        </DLMenu>
                    </Table.Cell>
                </Table.Row>
            );
        } );

        return rows;
    }
}
SortableContentsTable.defaultProps = {};

export default connect()( SortableContentsTable );
